import React from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import ArrowAccordion from "../ArrowAccordion";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Dragicon from "../../Dragicon/Dragicon";

function EditorAccordian({ children, ...props }) {
  return (
    <Accordion className="test" defaultActiveKey="0" activeKey={props.active}>
      <Card className="mb-3 Accordian_collapsing_time">
        <div
          as={Button}
          variant="link"
          style={{ cursor: "pointer", overflow: "hidden" }}
          className="btn-link btn"
        >
          <Card.Header
            className="d-flex justify-content-between align-items-center bg-transparent border-0 p-0 "
            onClick={() =>
              props.setActive(`${props.index}`, props.heading, props.index)
            }
          >
            <div className="d-flex align-items-center">
              {/* <div style={{ alignSelf: "center" }}>
                {props && props.provided && (
                  <Dragicon provided={props.provided} basic="basic" />
                )}
              </div> */}
              <div>
                <div className="d-flex  mr-3">
                  <div className="text-left  innersection-information">
                    {props.heading && props.heading != "" ? (
                      <h6>{props.heading && props.heading}</h6>
                    ) : (
                      <h6 className="mb-0">{`${props.heading_empty} - ${
                        props && props.index + 1
                      }`}</h6>
                    )}
                  </div>
                </div>
                {/* <div className="d-flex">
                  {props && !props.hide && (
                    <div className="ml-3 mt-1 innersection-information">
                      <p className="m-0">
                        {props.content && props.content != ""
                          ? props.content && props.content
                          : "Add More Details"}
                      </p>
                    </div>
                  )}
                </div> */}
              </div>
            </div>

            <div>
              <ArrowAccordion
                eventKey={`${props.index}`}
                active={props.active}
                setActive={props.setActive}
              />
            </div>
          </Card.Header>
        </div>
        <Accordion.Collapse className="" eventKey={`${props.index}`}>
          <Card.Body>{children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
}

export default EditorAccordian;
